
import React from 'react';
import { Control } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { RegistrationFormValues } from '@/schemas/registrationSchema';
import { Briefcase, Building } from 'lucide-react';

interface JobInfoFieldsProps {
  control: Control<RegistrationFormValues>;
}

const JobInfoFields: React.FC<JobInfoFieldsProps> = ({ control }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-base font-medium text-gray-700 mb-2">Thông tin nghề nghiệp</h3>
      
      <div className="space-y-4">
        <FormField
          control={control}
          name="job"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="flex items-center gap-1.5">
                <Briefcase className="h-4 w-4 text-blue-500" />
                <span>Công việc hiện tại</span>
              </FormLabel>
              <FormControl>
                <Input 
                  placeholder="Ví dụ: Giáo viên, Kỹ sư, Bác sĩ..." 
                  {...field} 
                  value={field.value || ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="workplace"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="flex items-center gap-1.5">
                <Building className="h-4 w-4 text-blue-500" />
                <span>Nơi công tác</span>
              </FormLabel>
              <FormControl>
                <Input 
                  placeholder="Ví dụ: Trường THPT Chuyên Lê Hồng Phong, Công ty ABC..." 
                  {...field} 
                  value={field.value || ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};

export default JobInfoFields;
